import React from "react"
import { Button, Table, Icon } from "semantic-ui-react"
import { ShardedAnalyticsCard } from "./ShardedAnalyticsCard"
import { ShardedAnalyticsDonut } from "./ShardedAnalyticsDonut"
import DateRangeDonutPicker from "./DateRangeDonutPicker"
import PropTypes from "prop-types"
import { format } from "date-fns"
import bind from "bind-decorator"
import { withTranslation } from "react-i18next"
import InfiniteCalendar, { Calendar, withRange } from "react-infinite-calendar"
import Select from "semantic-ui-react/dist/commonjs/addons/Select/Select"
import SharderLineGraphicDatePicker from "./SharderLineGraphicDatePicker"

const media = window.innerWidth > 600

const CalendarWithRange = withRange(Calendar)

const dateTypes = ["weeks", "months", "years"]

const dataTypes = ["sales", "purchases", "profit"]

const theme = {
  selectionColor: "#4d4d4d",
  textColor: {
    default: "#333",
    active: "#FFF",
  },
  accentColor: "#1B1C1D",
  weekdayColor: "#1B1C1D",
  headerColor: "#1B1C1D",
  floatingNav: {
    background: "#696969",
    color: "#FFF",
    chevron: "#FFF",
  },
  todayColor: "#1B1C1D",
}

const displayOptions = {
  showHeader: false,
}

@withTranslation()
export default class ShardedAnalyticsHolder extends React.Component {
  state = {
    selectTags: {},
    dateType: "",
    tagsCount: 0,
    selectDonutTags: {},
    donutTagsCount: 0,
  }

  componentDidMount() {
    this.createDonutSelectDateBlock()
    this.props.createShardedAnalytic("", "", "")
  }

  // Optiion of Select
  selectOptions = () => {
    const { t } = this.props
    return [
      { key: "", value: "", text: t("select") },
      { key: "sale", value: "sale", text: t("sales") },
      { key: "purchase", value: "purchase", text: t("purchasesPage") },
      { key: "profit", value: "profit", text: t("profit") },
    ]
  }

  selectDateTypes = () => {
    const { t } = this.props
    return [
      { key: "", value: "", text: t("select") },
      { key: "weeks", value: "weeks", text: t("weeks") },
      { key: "years", value: "years", text: t("years") },
      { key: "months", value: "months", text: t("months") },
    ]
  }

  setDateType = (type) => this.setState({ dateType: type })

  deleteAllDateAdders = () => {
    const tags = this.state.selectTags
    for (let i = 0; i < this.props.last + 1; i++) {
      if (tags[i] !== null && tags[i] !== undefined) {
        this.setState()
        tags[i] = null
        this.props.deleteShardedAnalyticFunction(i)
      }
    }
    this.setState({ selectTags: tags })
  }

  deleteTag = (id) => {
    if (
      this.state.selectTags[id] !== null &&
      this.state.selectTags[id] !== undefined
    ) {
      const selectTags = this.state.selectTags
      let tagsCount = this.state.tagsCount
      tagsCount -= 1
      selectTags[id] = null
      this.props.deleteShardedAnalyticFunction(id)
      this.setState({ selectTags: selectTags })
      this.setState({ tagsCount: tagsCount })
    } else if (
      this.state.selectDonutTags[id] !== null &&
      this.state.selectDonutTags[id] !== undefined
    ) {
      const selectDonutTags = this.state.selectDonutTags
      let donutTagsCount = this.state.donutTagsCount
      donutTagsCount -= 1
      selectDonutTags[id] = null
      this.props.deleteShardedAnalyticFunction(id)
      this.setState({ selectDonutTags: selectDonutTags })
      this.setState({ donutTagsCount: donutTagsCount })
    }
  }

  createSelectDateAdder = () => {
    document.getElementById("SelectDateAdderButton").style.display = "block"
  }

  createSelectDateBlock = () => {
    const last = this.props.last
    let tagsCount = this.state.tagsCount
    if (tagsCount === 5) {
    } else {
      const selectTags = this.state.selectTags
      const t = this.props.t
      tagsCount += 1
      selectTags[last] = (
        <div>
          <Select
            style={{ display: "inline-block" }}
            placeholder={t("select")}
            options={this.selectOptions()}
            onChange={(event, value) => {
              this.props.setShardedAnalyticTypeFunction(last, value.value)
              if (
                this.props.startDates[last] !== "" &&
                this.props.startDates[last] !== null &&
                this.props.startDates[last] !== undefined &&
                this.props.endDates[last] !== "" &&
                this.props.endDates[last] !== null &&
                this.props.endDates[last] !== undefined
              ) {
                this.props.refreshShardedAnalytic(last)
              }
            }}
          />
          <SharderLineGraphicDatePicker
            type={this.state.dateType}
            setShardedAnalyticDateFunction={
              this.props.setShardedAnalyticDateFunction
            }
            refreshShardedAnalytic={this.props.refreshShardedAnalytic}
            id={last}
          />
          <Button onClick={() => this.deleteTag(last)} negative>
            <Icon name="close" />
          </Button>
        </div>
      )
      this.setState({ selectTags: selectTags, tagsCount: tagsCount })
    }
  }

  createDonutSelectDateBlock = () => {
    const last = this.props.last
    let tagsCount = this.state.donutTagsCount
    if (tagsCount === 5) {
    } else {
      const selectTags = this.state.selectDonutTags
      const t = this.props.t
      tagsCount += 1
      selectTags[last] = (
        <div>
          <Select
            placeholder={t("select")}
            options={this.selectOptions()}
            onChange={(event, value) => {
              this.props.setShardedAnalyticTypeFunction(last, value.value)
              if (
                this.props.startDates[last] !== "" &&
                this.props.startDates[last] !== null &&
                this.props.startDates[last] !== undefined &&
                this.props.endDates[last] !== "" &&
                this.props.endDates[last] !== null &&
                this.props.endDates[last] !== undefined
              ) {
                this.props.refreshShardedAnalytic(last)
              }
            }}
          />
          <DateRangeDonutPicker
            id={last}
            startDate={this.props.startDates[last]}
            endDate={this.props.endDates[last]}
            onRangeChange={this.props.onRangeChange}
            setShardedAnalyticDateFunction={
              this.props.setShardedAnalyticDateFunction
            }
            refreshShardedAnalytic={this.props.refreshShardedAnalytic}
          />
          <Button onClick={() => this.deleteTag(last)} negative>
            <Icon name="close" />
          </Button>
        </div>
      )
      this.setState({ selectDonutTags: selectTags, donutTagsCount: tagsCount })
    }
  }

  toData = (graphType) => {
    const selectTags = this.state.selectTags
    const selectDonutTags = this.state.selectDonutTags
    const analytics = this.props.analytics
    const last = this.props.last
    const result = []
    if (graphType === "line") {
      for (let i = 0; i < last; i++) {
        if (selectTags[i] !== null && selectTags[i] !== undefined) {
          if (analytics[i] !== undefined && analytics[i] !== null) {
            result.push(analytics[i])
          }
        }
      }
    } else if (graphType === "donut") {
      for (let i = 0; i < last; i++) {
        if (selectDonutTags[i] !== null && selectDonutTags[i] !== undefined) {
          if (analytics[i] !== undefined && analytics[i] !== null) {
            result.push(analytics[i])
          }
        }
      }
    }
    return result
  }

  isLoadings = (graphType) => {
    const selectTags = this.state.selectTags
    const selectDonutTags = this.state.selectDonutTags
    const isLoadings = this.props.isLoadings
    const last = this.props.last
    let result = 0
    if (graphType === "line") {
      for (let i = 0; i < last; i++) {
        if (selectTags[i] !== null && selectTags[i] !== undefined) {
          result += isLoadings[i]
        }
      }
    } else if (graphType === "donut") {
      for (let i = 0; i < last; i++) {
        if (selectDonutTags[i] !== null && selectDonutTags[i] !== undefined) {
          result += isLoadings[i]
        }
      }
    }
    return result
  }

  toTypes = (graphType) => {
    const selectTags = this.state.selectTags
    const selectDonutTags = this.state.selectDonutTags
    const types = this.props.types
    const last = this.props.last
    const result = []
    if (graphType === "line") {
      for (let i = 0; i < last; i++) {
        if (selectTags[i] !== null && selectTags[i] !== undefined) {
          result.push(types[i])
        }
      }
    } else if (graphType === "donut") {
      for (let i = 0; i < last; i++) {
        if (selectDonutTags[i] !== null && selectDonutTags[i] !== undefined) {
          result.push(types[i])
        }
      }
    }
    return result
  }

  getSelectTags = () => {
    const result = []
    for (let i = 0; i < this.props.last + 1; i++) {
      if (
        this.state.selectTags[i] !== null &&
        this.state.selectTags[i] !== undefined
      ) {
        result.push(this.state.selectTags[i])
      }
    }
    return result
  }

  getDonutSelectTags = () => {
    const result = []
    for (let i = 0; i < this.props.last + 1; i++) {
      if (
        this.state.selectDonutTags[i] !== null &&
        this.state.selectDonutTags[i] !== undefined
      ) {
        result.push(this.state.selectDonutTags[i])
      }
    }
    return result
  }

  @bind
  refreshShardedAnalytics() {
    if (!this.isLoading()) {
      const {
        onRefreshShardedSale,
        onRefreshShardedPurchase,
        onRefreshShardedProfit,
      } = this.props
      onRefreshShardedSale()
      onRefreshShardedPurchase()
      onRefreshShardedProfit()
    }
  }

  @bind
  refreshShardedProductAnalytics() {
    console.log("RESULT ", this.props.resultText)
    if (!this.isLoading()) {
      const {
        onRefreshShardedProductSale,
        onRefreshShardedProductPurchase,
        onRefreshShardedProductProfit,
        resultText,
      } = this.props
      onRefreshShardedProductSale(resultText)
      onRefreshShardedProductPurchase(resultText)
      onRefreshShardedProductProfit(resultText)
    }
  }

  static renderTable(data, i) {
    return (
      <Table.Row key={i}>
        <Table.Cell content={data.date} />
        <Table.Cell content={data.sale || 0} />
        <Table.Cell content={data.purchase || 0} />
        <Table.Cell content={data.profit || 0} />
      </Table.Row>
    )
  }

  getTableData() {
    const { profitAnalytics, purchaseAnalytics, saleAnalytics } = this.props
    const tableData = new Map()
    const tryMap = (name) => (item) => {
      const date = format(new Date(item.at), "dd-MM-yyyy, HH:mm")
      if (tableData.has(date)) {
        tableData.get(date)[name] = item.value
      } else {
        tableData.set(date, { at: item.at, date, [name]: item.value })
      }
    }
    profitAnalytics.data.forEach(tryMap("profit"))
    purchaseAnalytics.data.forEach(tryMap("purchase"))
    saleAnalytics.data.forEach(tryMap("sale"))
    return [...tableData.values()].sort((a, b) => {
      if (a.at < b.at) {
        return -1
      }
      if (a.at > b.at) {
        return 1
      }
      return 0
    })
  }

  render() {
    const { t } = this.props
    const data = this.getTableData()
    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>Дата</Table.HeaderCell>
        <Table.HeaderCell>{t("sales")}, тенге</Table.HeaderCell>
        <Table.HeaderCell>{t("purchasesPage")}, тенге</Table.HeaderCell>
        <Table.HeaderCell>{t("profit")}, тенге</Table.HeaderCell>
      </Table.Row>
    )
    let salesTotal = 0
    let purchasesTotal = 0
    let profitTotal = 0
    data.map((d) => {
      salesTotal += d.sale || 0
      purchasesTotal += d.purchase || 0
      profitTotal += d.profit || 0
    })
    const footerRow = (
      <Table.Row>
        <Table.HeaderCell>{t("total")}</Table.HeaderCell>
        <Table.HeaderCell>
          {Math.floor(salesTotal * 100) / 100}
        </Table.HeaderCell>
        <Table.HeaderCell>
          {Math.floor(purchasesTotal * 100) / 100}
        </Table.HeaderCell>
        <Table.HeaderCell>
          {Math.floor(profitTotal * 100) / 100}
        </Table.HeaderCell>
      </Table.Row>
    )
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h2>{t("Comparative Line Chart")}</h2>
          <div style={{ marginBottom: 20, width: media ? "60%" : "100%" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Select
                placeholder={t("select")}
                options={this.selectDateTypes()}
                onChange={(event, value) => {
                  this.deleteAllDateAdders()
                  this.setState({
                    tagsCount: 0,
                    createSelectAdder: value.value,
                  })
                  console.log(value.value)
                  return this.setDateType(value.value)
                }}
              />
              <Button
                positive
                // id="SelectDateAdderButton"
                disabled={!this.state.createSelectAdder}
                onClick={() => {
                  this.createSelectDateBlock()
                  this.props.createShardedAnalytic("", "", "")
                }}
                // style={{ display: "none" }}
              >
                {t("AddChartToCompare")}
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {this.getSelectTags().map((el) => {
                return el
              })}
            </div>
          </div>
          <div
            style={{
              width: media ? "60%" : "100%",
              minWidth: media ? 700 : window.innerWidth / 2,
            }}
          >
            <ShardedAnalyticsCard
              unit="тенге"
              titles={this.toTypes("line")}
              data={this.toData("line")}
              isLoading={this.isLoadings("line")}
              dateType={this.state.dateType}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 40,
          }}
        >
          <h2>
            {t("Comparative graph for time periods of different lengths")}
          </h2>
          <div
            style={{
              width: media ? "60%" : "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 30,
            }}
          >
            <Button
              positive
              onClick={() => {
                this.createDonutSelectDateBlock()
                this.props.createShardedAnalytic("", "", "")
              }}
              style={{ marginBottom: 10 }}
            >
              {t("AddComparableChart")}
            </Button>
            <div>
              {this.getDonutSelectTags().map((el) => {
                return el
              })}
            </div>
          </div>
          <div style={{ width: media ? "60%" : "100%" }}>
            <ShardedAnalyticsDonut
              titles={this.toTypes("donut")}
              data={this.toData("donut")}
              isLoading={this.isLoadings("donut")}
            />
          </div>
        </div>
      </div>
    )
  }
}

ShardedAnalyticsHolder.propTypes = {
  onRangeChange: PropTypes.func.isRequired,
  onProductRangeChange: PropTypes.func.isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onRefreshShardedSale: PropTypes.func.isRequired,
  onRefreshShardedPurchase: PropTypes.func.isRequired,
  onRefreshShardedProfit: PropTypes.func.isRequired,
  profitAnalytics: PropTypes.object.isRequired,
  saleAnalytics: PropTypes.object.isRequired,
  purchaseAnalytics: PropTypes.object.isRequired,
}
